import { useEffect } from 'react';
import { PapiAttachmentFile } from '@wix/da-papi-types';
import { ADDITIONAL_MEDIA_ID_PREFIX } from '../constants';
import { hasWindow } from '../../utils/browser';
import { ImageSource } from '../../DeviationViews/Full/types';

/** Checks and attempts to extract an index from window.location.hash and
 *  then calls `whenFound` on the `PapiAttachmentFile` at that index */
export function useMultiArtDeepLinking(
  additionalMedia: PapiAttachmentFile[],
  whenFound: React.Dispatch<React.SetStateAction<ImageSource | undefined>>
) {
  useEffect(() => {
    // slice past '#'
    const hash = window.location.hash.slice(1);
    if (!hasWindow() || !hash.startsWith(ADDITIONAL_MEDIA_ID_PREFIX)) {
      return;
    }
    const hashIdIndexString = window.location.hash
      .slice(1)
      .replace(ADDITIONAL_MEDIA_ID_PREFIX, '');
    let hashIdIndex = Number.parseInt(hashIdIndexString, 10);
    if (!Number.isSafeInteger(hashIdIndex) || hashIdIndex < 2) {
      return;
    }

    // adjust from nerd-based to people-based number system
    // and assume 1 is the main image (where we'd end up on page load anyway)
    hashIdIndex = hashIdIndex - 2;
    if (additionalMedia?.[hashIdIndex]) {
      whenFound(additionalMedia?.[hashIdIndex]);
    }
  }, [additionalMedia, whenFound]);
}
